import { FC } from 'react';

import { IconProps } from './types';

export const RubleOutlineIcon: FC<IconProps> = ({
	color = 'currentColor',
	height = 22,
	size,
	width = 22,
	className,
}) => (
	<svg
		className={className}
		viewBox="0 0 22 22"
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			d="M0 11c0 6.07 4.935 11 11 11s11-4.93 11-11S17.065 0 11 0 0 4.93 0 11Zm2 0c0-4.96 4.038-9 9-9 4.963 0 9 4.04 9 9s-4.037 9-9 9c-4.962 0-9-4.04-9-9Z"
		/>
		<path
			fill={color}
			d="M7.045 10.862h1.19V6.298a15.784 15.784 0 0 1 2.772-.238c.532 0 1.04.042 1.526.126.485.084.91.238 1.274.462.364.224.656.532.875.924.22.392.329.896.329 1.512 0 .56-.11 1.038-.329 1.435a2.73 2.73 0 0 1-.868.959c-.36.243-.77.42-1.232.532a5.95 5.95 0 0 1-1.407.168h-1.022v.812h2.436v1.316h-2.436V16H8.235v-1.694h-1.19V12.99h1.19v-.812h-1.19v-1.316Zm3.108-.084h.77c.28 0 .546-.028.798-.084.252-.056.474-.15.665-.28.191-.13.34-.296.448-.497.107-.2.161-.45.161-.749 0-.55-.173-.933-.518-1.148-.345-.215-.784-.322-1.316-.322-.196 0-.385.005-.567.014-.182.01-.329.023-.441.042v3.024Z"
		/>
	</svg>
);
